module.exports = __webpack_public_path__ + "static/img/donga-stillen.1901bc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/donga-stillen.jpg
// module id = JqSy
// module chunks = 0